<template>
   <v-layout row wrap>

      <v-flex class="sm12" v-if="barStatus > 0">
         <v-toolbar dense :color="barStatus === 1 ? 'orange' : barStatus === 2 ? 'green' :  'red'" dark>
            <span v-if="barStatus >= 2"> {{ barStatusText }} </span>
            <span v-if="barStatus === 1">
               TEST VECTOR
               <input type="file" @change="onTestFileChange">
            </span>
            <v-spacer></v-spacer>
            <span v-if="barStatus === 1 && getMemoryInstanceArray().length > 0">
               MEMORY CONTENTS
               <input type="file" @change="onMemFileChange">
            </span>
         </v-toolbar>
      </v-flex>

      <v-flex xs12>
         <v-card>
            <v-list>
               <v-btn @click="onBarButtonClick"
                     fab small color="yellow"
                     top right absolute>
                  <v-icon>{{ barStatus === 0 ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
               </v-btn>
               <v-btn v-if="otherGroups.length > 0"
                     @click="showOthers = !showOthers"
                     fab small color="yellow"
                     bottom left absolute>
                  <v-icon>{{ showOthers ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
               </v-btn>

               <template v-for="signalGroup in parameterGroups">
                  <v-list-tile>
                     <v-list-tile-action>
                        <v-icon :color="inputOutputIconColor(signalGroup)" v-if="signalGroup.isInput || signalGroup.isOutput" @click="clear(signalGroup)">
                           {{ inputOutputIcon(signalGroup) }}
                        </v-icon>
                     </v-list-tile-action>
                     <v-list-tile-content>{{ signalGroup.name }}</v-list-tile-content>
                     <v-list-tile-action>
                        <div>
                        <template v-for="index in signalGroup.equipotentialIndexes">
                           <v-icon @click="onIconClick(index)" :disabled="!signalGroup.isInput">{{ checkIcon(index, signalGroup.isInput) }}</v-icon>
                        </template>
                        </div>
                     </v-list-tile-action>
                  </v-list-tile>
               </template>
            </v-list>
         </v-card>

         <v-card v-if="showOthers">
            <v-divider/>
               <template v-for="signalGroup in otherGroups">
                  <v-list-tile>
                     <v-list-tile-action>
                        <v-icon></v-icon>
                     </v-list-tile-action>
                     <v-list-tile-content>{{ signalGroup.name }}</v-list-tile-content>
                     <v-list-tile-action>
                        <div>
                        <template v-for="index in signalGroup.equipotentialIndexes">
                           <v-icon :disabled="true">{{ checkIcon(index, false) }}</v-icon>
                        </template>
                        </div>
                     </v-list-tile-action>
                  </v-list-tile>
               </template>
         </v-card>

      </v-flex>
   </v-layout>
</template>


<script>
   import Vue from 'vue'
   import _ from 'lodash'
   import utilities from '@/utilities/shdl/shdlUtilities.js'
   import binutils from '@/utilities/binutils.js'
   const lineTestParser = require('@/utilities/shdl/shdl_test_line_parser.js')


  export default {

      props: {
         module: Object,
      },

      data () {
         return {
            previousValues: null,
            currentValues: null,
            showOthers: false,
            barStatus: 0, // 0: closed, 1: open but not started, 2: started & ok, 3: started & KO
            barStatusText: null,
         }
      },

      created: function() {
         this.previousValues = this.equipotentials.map(function(equipotential) {
            return null
         })
         this.currentValues = this.equipotentials.map(function(equipotential) {
            return null
         })
      },

      mounted: function() {
         let error = this.updateState()
         if (error) {
            this.barStatus = 3
            this.barStatusText = error
         }
      },

      computed: {
         moduleParseInfo () {
            return this.$store.state.shdl.module2parseInfo[this.module.id]
         },
         structure () {
            return this.moduleParseInfo.structure
         },
         equipotentials () {
            return this.moduleParseInfo.equipotentials
         },
         parameterGroups () {
            // build homogeneous groups in terms of input/output
            let groups = []
            for (let i = 0; i < this.structure.params.length; i++) {
               let parameter = this.structure.params[i]
               if (parameter.type === 'scalar') {
                  // each scalar has its own group
                  let equipotentialIndex = this.equipotentials["__" + parameter.name]
                  let equipotential = this.equipotentials[equipotentialIndex]
                  groups.push({
                     name: parameter.name,
                     isInput: equipotential.isInput,
                     isOutput: equipotential.isOutput,
                     equipotentialIndexes: [equipotentialIndex]
                  })
               } else {
                  // a vector parameter may result in several groups
                  let firstIndex
                  let firstSignalName
                  let firstEquipotential
                  let equipotentialIndexes
                  let reset = true
                  let parameterArity = utilities.parameterArity(parameter)
                  let j
                  for (j = 0; j < parameterArity; j++) {
                     let signalName = utilities.parameterNameAtIndex(parameter, j)
                     let equipotentialIndex = this.equipotentials["__" + signalName]
                     let equipotential = this.equipotentials[equipotentialIndex]
                     if (reset) {
                        firstIndex = parameter.start - j
                        firstSignalName = utilities.parameterNameAtIndex(parameter, j)
                        firstEquipotential = this.equipotentials[this.equipotentials["__" + firstSignalName]]
                        equipotentialIndexes = []
                        reset = false
                     }
                     if (equipotential.isInput && firstEquipotential.isInput || equipotential.isOutput && firstEquipotential.isOutput) {
                        equipotentialIndexes.push(equipotentialIndex)
                     } else {
                        groups.push({
                           name: `${parameter.name}[${firstIndex}..${parameter.start - j + 1}]`,
                           isInput: firstEquipotential.isInput,
                           isOutput: firstEquipotential.isOutput,
                           equipotentialIndexes: equipotentialIndexes,
                        })
                        reset = true
                     }
                  }
                  if (equipotentialIndexes.length > 0) {
                     groups.push({
                        name: `${parameter.name}[${firstIndex}:${parameter.start - j + 1}]`,
                        isInput: firstEquipotential.isInput,
                        isOutput: firstEquipotential.isOutput,
                        equipotentialIndexes: equipotentialIndexes,
                     })
                  }
               }
            }
            return groups
         },
         otherGroups () {
            // collect all remaining equipotentials
            let otherEquipotentials = this.equipotentials.filter(function(equipotential) {
               if (equipotential === undefined) return false // alias empty slot
               if (equipotential.name === null) return false
               if (equipotential.isInput) return false
               if (equipotential.isOutput) return false
               return true
            })
            // sort them by name in descending order, then by decreasing indexes for vectors
            otherEquipotentials.sort(function(a, b) {
               if (a.name < b.name) return 1
               if (a.name > b.name) return -1
               return 0
            })
            otherEquipotentials.sort(function(a, b) {
               let ai = a.name.indexOf('[')
               let bi = a.name.indexOf('[')
               let aPrefix = ai === -1 ? a.name : a.name.substring(0, ai)
               let bPrefix = bi === -1 ? b.name : b.name.substring(0, bi)
               if (aPrefix < bPrefix) return 1
               if (aPrefix > bPrefix) return -1
               // same prefix
               if (ai === -1) return 0
               // extract last index for a, first index for b
               let aj = a.name.indexOf('..')
               let ak = a.name.indexOf(']')
               let aLastIndex = parseInt(a.name.substring((aj === -1 ? ai+1 : aj+2), ak))
               let bj = b.name.indexOf('..')
               let bk = b.name.indexOf(']')
               let bFirstIndex = parseInt(b.name.substring(bi+1, (bj === -1 ? bk : bj)))
               if (aLastIndex < bFirstIndex) return 1
               if (aLastIndex > bFirstIndex) return -1
               return 0
            })

            // make groups by name prefix and consecutive indexes
            let currentPrefix = null
            let startIndex = null
            let stopIndex = null
            let equipotentialIndexes = null
            let groups = []
            for (let i = 0; i < otherEquipotentials.length; i++) {
               let equipotential = otherEquipotentials[i]
               let x = equipotential.name.indexOf('[')
               if (x === -1) {
                  // scalar
                  if (currentPrefix !== null) {
                     // flush current group
                     let range = startIndex === stopIndex ? `${startIndex}` : `${startIndex}:${stopIndex}`
                     groups.push({
                        name: `${currentPrefix}[${range}]`,
                        equipotentialIndexes: equipotentialIndexes,
                     })
                  }
                  // a scalar has its own group
                  groups.push({
                     name: equipotential.name,
                     equipotentialIndexes: [equipotential.index]
                  })
                  currentPrefix = null
               } else {
                  // vector
                  let prefix = equipotential.name.substring(0, x)
                  let index = parseInt(equipotential.name.substring(x + 1, equipotential.name.length - 1))
                  if (currentPrefix === null) {
                     // start new group
                     currentPrefix = prefix
                     startIndex = index
                     stopIndex = index
                     equipotentialIndexes = [equipotential.index]
                  } else if (prefix == currentPrefix) {
                     if (index === stopIndex - 1) {
                        // next consecutive index: continues current group
                        stopIndex = index
                        equipotentialIndexes.push(equipotential.index)
                     } else {
                        // same name prefix, but break in indexes: flush current group
                        let range = startIndex === stopIndex ? `${startIndex}` : `${startIndex}:${stopIndex}`
                        groups.push({
                           name: `${currentPrefix}[${range}]`,
                           equipotentialIndexes: equipotentialIndexes,
                        })
                        // start new group
                        currentPrefix = prefix
                        startIndex = index
                        stopIndex = index
                        equipotentialIndexes = [equipotential.index]
                     }
                  } else {
                     // change of name prefix: flush current group
                     groups.push({
                        name: `${currentPrefix}[${startIndex}:${stopIndex}]`,
                        equipotentialIndexes: equipotentialIndexes,
                     })
                     // start new group
                     currentPrefix = prefix
                     startIndex = index
                     stopIndex = index
                     equipotentialIndexes = [equipotential.index]
                  }
                  if (i === otherEquipotentials.length -1 && currentPrefix !== null) {
                     // flush current group
                     let range = startIndex === stopIndex ? `${startIndex}` : `${startIndex}:${stopIndex}`
                     groups.push({
                        name: `${currentPrefix}[${range}]`,
                        equipotentialIndexes: equipotentialIndexes,
                     })
                  }
               }

            }
            return groups
         },
      },

      methods: {
         inputOutputIcon: function(signalGroup) {
            if (signalGroup.isInput) {
               return 'fa-long-arrow-alt-right'
            } else if (signalGroup.isOutput) {
               return 'fa-long-arrow-alt-left'
            } else {
               return null
            }
         },
         inputOutputIconColor: function(signalGroup) {
            if (signalGroup.isInput) {
               return 'pink'
            } else if (signalGroup.isOutput) {
               return 'green'
            } else {
               return null
            }
         },

         checkIcon: function(index, isInput) {
            if (this.currentValues[index] === null) {
               return isInput ? 'indeterminate_check_box' : 'remove_circle'
            } else if (this.currentValues[index]) {
               return isInput ? 'check_box' : 'radio_button_checked'
            } else {
               return isInput ? 'check_box_outline_blank' : 'radio_button_unchecked'
            }
         },
         onIconClick: function(index) {
            if (this.currentValues[index] === null) {
               Vue.set(this.currentValues, index, false)
            } else {
               Vue.set(this.currentValues, index, !this.currentValues[index])
            }
            let error = this.updateState()
            if (error) {
               this.barStatus = 3
               this.barStatusText = error
            }
         },

         clear: function(signalGroup) {
            if (!signalGroup.isInput) return
            let self = this
            let first = this.currentValues[signalGroup.equipotentialIndexes[0]]
            let toggled = (first === null) ? false : (first ? null : true)
            signalGroup.equipotentialIndexes.forEach(function(index) {
               Vue.set(self.currentValues, index, toggled)
            })
            // propagate changes
            let error = this.updateState()
            if (error) {
               this.barStatus = 3
               this.barStatusText = error
            }
         },

         updateState: function() {
            // TO IMPROVE : ALL EQUIPOTENTIALS ARE REEVALUATED AT EACH CYCLE
            // USE 'uses' ATTRIBUTE TO ONLY UPDATE WHEN NECESSARY
            let change = true
            let cycles = 0
            let error = ''
            while (change && cycles < 100) {
               // evaluation cycle
               change = false
               let nextValues = []
               // plain loop is used because we need to break
               for (let index = 0; index < this.equipotentials.length; index++) {
                  let equipotential = this.equipotentials[index]
                  if (equipotential === undefined) continue // alias empty slot
                  if (equipotential.isInput) continue
                  
                  let previousValue = this.currentValues[index]
                  let value = this.equipotentialValue(index, this.currentValues, this.previousValues)
                  change = change | (value != previousValue)
                  nextValues[index] = value
               }
               // update dataArray all at once (not one by one) for the next evaluation cycle
               for (let index = 0; index < this.equipotentials.length; index++) {
                  this.previousValues[index] = this.currentValues[index]
                  let equipotential = this.equipotentials[index]
                  if (equipotential === undefined) continue // alias empty slot
                  if (equipotential.isInput) continue
                  Vue.set(this.currentValues, index, nextValues[index])
               }
               cycles += 1
            }
            // now that propagation has stabilized, check for tri-state short-circuits
            // plain loop is used because we need to break
            for (let index = 0; index < this.equipotentials.length; index++) {
               let equipotential = this.equipotentials[index]
               if (equipotential === undefined) continue // alias empty slot
               if (equipotential.type !== 'tri-state') continue

               let outputEnableValues = equipotential.sources.map(source => this.currentValues[source.oeEquipotential])
               let indexes = outputEnableValues.reduce((accu, value, index) => value === true ? [index].concat(accu) : accu, [])
               if (indexes.length > 1) {
                  let conflicting_sources = indexes.map(index => equipotential.sources[index])
                  let conflictNames = conflicting_sources.map(src => {
                     let srcText = this.equipotentials[src.srcEquipotential].name || "<anonymous equipotential>"
                     let oeText = this.equipotentials[src.oeEquipotential].name || "<anonymous equipotential>"
                     return `${srcText}:${oeText}`
                  })
                  error = `*** short-circuit on ${equipotential.name} between: ${conflictNames.join(' and ')}`
                  break
               }
            }
            return error
         },

         // return false (0), true (1) or null (indeterminate or short-circuit)
         equipotentialValue: function(equipotentialIndex, dataArray, previousValueArray) {
            if (dataArray === null) return null
            let equipotential = this.equipotentials[equipotentialIndex]
            if (equipotential === undefined) {
               equipotential = equipotential
            }
            if (equipotential.isInput) {
               return dataArray[equipotentialIndex]

            } else if (equipotential.type === 'constant') {
               // return equipotential.name === '>1' ? true : false
               return equipotential.cvalue === 1 ? true : equipotential.cvalue === 0 ? false : null

            } else if (equipotential.type === 'combinatorial') {
               return this.evaluateFormula(equipotential.formula, dataArray)

            } else if (equipotential.type === 'tri-state') {
               let outputEnableValues = equipotential.sources.map(source =>
                  dataArray[source.oeEquipotential]
               )
               let indexes = outputEnableValues.reduce((accu, value, index) => value === true ? [index].concat(accu) : accu, [])
               if (indexes.length === 0) {
                  // no output enable is true -> indeterminate
                  return null
               }
               if (indexes.length === 1) {
                  return dataArray[equipotential.sources[indexes[0]].srcEquipotential]
               }
               // short-circuit: return null
               // Short-circuits do not break simulation during propagation instabilities
               // They are checked again when progation has stabilized (see updateState())
               return null

            } else if (equipotential.type === 'sequential') {
               if (equipotential.rst !== undefined) {
                  //let resetValue = this.equipotentialValue(equipotential.rst, dataArray, previousValueArray)
                  let resetValue = dataArray[equipotential.rst]
                  if (resetValue === true) {
                     // reset exists and is on
                     return false
                  }
               }
               if (equipotential.set !== undefined) {
                  //let setValue = this.equipotentialValue(equipotential.set, dataArray, previousValueArray)
                  let setValue = dataArray[equipotential.set]
                  if (setValue === true) {
                     // set exists and is on
                     return true
                  }
               }
               if (equipotential.en !== undefined) {
                  //let enValue = this.equipotentialValue(equipotential.en, dataArray, previousValueArray)
                  let enValue = dataArray[equipotential.en]
                  if (enValue === false) {
                     // enable exists and is false -> return current value (no change)
                     return dataArray[equipotentialIndex]
                  }
               }
               // no reset & no enable or enable true -> check clock tick
               let previousClkValue = previousValueArray[equipotential.clk]
               let currentClkValue = dataArray[equipotential.clk]
               if (previousClkValue === false && currentClkValue === true) {
                  // rising edge on clock -> return computed value
                  return this.evaluateFormula(equipotential.formula, dataArray)
               } else {
                  // no clock tick: keep current value
                  return dataArray[equipotentialIndex]
               }

            } else if (equipotential.type === 'rom' || equipotential.type === 'ram_aread_swrite') {
               let addressKey = equipotential.addrs.map(equipotentialIndex => {
                  return dataArray[equipotentialIndex]
               }).join()
               if (equipotential.type === 'ram_aread_swrite') {
                  // check clock tick & wr
                  let previousClkValue = previousValueArray[equipotential.clk]
                  let currentClkValue = dataArray[equipotential.clk]
                  let currentWrValue = dataArray[equipotential.wr]
                  if (previousClkValue === false && currentClkValue === true && currentWrValue === true) {
                     // rising edge on clock + write -> store din value in dict
                     equipotential.dict[addressKey] = dataArray[equipotential.din]
                  }
               }
               // in all cases return current dict value
               let value = equipotential.dict[addressKey]
               return value === undefined ? null : value
            }
            return null
         },

         evaluateFormula: function(formula, dataArray) {
            let self = this
            if (formula.op === 'or') {
               let one = formula.args.some(function(f) {
                  return (self.evaluateFormula(f, dataArray) === true)
               })
               if (one) {
                  return true
               }
               let zero = formula.args.every(function(f) {
                  return (self.evaluateFormula(f, dataArray) === false)
               })
               if (zero) {
                  return false
               }
               // indeterminate
               return null
            } else if (formula.op === 'and') {
               let zero = formula.args.some(function(f) {
                  return (self.evaluateFormula(f, dataArray) === false)
               })
               if (zero) {
                  return false
               }
               let one = formula.args.every(function(f) {
                  return (self.evaluateFormula(f, dataArray) === true)
               })
               if (one) {
                  return true
               }
               // indeterminate
               return null
            } else if (formula.op === 'maxterm') {
               let value = dataArray[formula.equipotentialIndex]
               if (value === null) {
                  return null
               } else {
                  if (formula.inverted) value = !value
                  return value
               }
            } else if (formula.op === 'expr') {
               // return this.equipotentialValue(formula.equipotentialIndex, dataArray, null)
               return dataArray[formula.equipotentialIndex]
            } else {
               // constant
               if (formula === '0') {
                  return false
               } else if (formula === '1') {
                  return true
               } else {
                  return null
               }
            }
         },

         onBarButtonClick() {
            if (this.barStatus === 0) {
               this.barStatus = 1
            } else {
               this.barStatus = 0
            }
         },

         onTestFileChange(e) {
            var files = e.target.files || e.dataTransfer.files
            if (!files.length) return

            var reader = new FileReader()
            var vm = this
            reader.onload = (e) => {
               let testContent = e.target.result
               vm.executeTest(testContent)
            }
            reader.readAsText(files[0])
         },

         executeTest: function(testContent) {
            this.barStatus = 2
            // split text in lines
            let lines = testContent.split(/\r?\n/)
            for (let i = 0; i < lines.length; i++) {
               let line = lines[i]
               if (line.trim().length == 0) continue
               this.barStatusText = `line ${i+1} / ${lines.length}`
               // execute line
               let status = this.executeLine(line)
               if (status.length > 0) {
                  this.barStatus = 3
                  this.barStatusText = ` line ${i+1} / ${lines.length} ${status}`
                  break
               }
               // update vue
               let error = this.updateState()
               if (error) {
                  this.barStatus = 3
                  this.barStatusText = ` line ${i+1} / ${lines.length} ${error}`
                  break
               }
            }
            if (this.barStatus === 2) {
               this.barStatusText = "SUCCESS"
            }
         },

         executeLine: function(line) {
            try {
               // parse line
               let command = lineTestParser.parse(line)
               if (command.cmd === 'comment') return ''
               if (command.signal.type === 'scalar') {
                  if (command.value.length !== 1) {
                     return "*** value arity error ***"
                  }
                  let signalName = command.signal.name
                  let equipotentialIndex = this.equipotentials["__" + signalName]
                  if (equipotentialIndex === undefined) {
                     return `*** unknown signal name: ${signalName} ***`
                  }
                  let value = command.value === '0' ? false : command.value === '1' ? true : null
                  if (command.cmd === 'set') {
                     Vue.set(this.currentValues, equipotentialIndex, value)
                  } else if (command.cmd === 'check') {
                     let currentValue = this.currentValues[equipotentialIndex]
                     if (currentValue !== value) {
                        return `*** expected ${signalName} = ${command.value} ***`
                     }
                  }
               } if (command.signal.type === 'vector') {
                  let vectorSize = command.signal.start - command.signal.stop + 1
                  if (vectorSize !== command.value.length) {
                     return "*** value arity error ***"
                  }
                  for (let index = command.signal.start; index >= command.signal.stop; index--) {
                     let signalName = `${command.signal.name}[${index}]`
                     let equipotentialIndex = this.equipotentials["__" + signalName]
                     if (equipotentialIndex === undefined) {
                        return `*** unknown signal name: ${signalName} ***`
                     }
                     let i = command.signal.start - index
                     let value = command.value[i] === '0' ? false : command.value[i] === '1' ? true : null
                     if (command.cmd === 'set') {
                        Vue.set(this.currentValues, equipotentialIndex, value)
                     } else if (command.cmd === 'check') {
                        let currentValue = this.currentValues[equipotentialIndex]
                        if (currentValue !== value) {
                           return `*** expected ${signalName} = ${command.value[i]} ***`
                        }
                     }
                  }
               }
               return ''
            } catch(err) {
               return "*** syntax error ***"
            }
         },

         onMemFileChange(e) {
            var files = e.target.files || e.dataTransfer.files
            if (!files.length) return

            var reader = new FileReader()
            var vm = this
            reader.onload = (e) => {
               let memContent = e.target.result
               vm.loadMemContents(memContent)
               vm.updateState()
            }
            reader.readAsText(files[0])
         },

         getMemoryInstanceArray: function() {
            let memoryEquipotentials = this.equipotentials.filter(function(equipotential) {
               if (equipotential.type === 'rom') return true
               if (equipotential.type === 'ram_aread_swrite') return true
            })
            let memoryInstanceArray = []
            memoryEquipotentials.forEach(equipotential => {
               if (memoryInstanceArray[equipotential.memUUID] === undefined) memoryInstanceArray[equipotential.memUUID] = []
               memoryInstanceArray[equipotential.memUUID][equipotential.memOutIndex] = equipotential
            })
            return memoryInstanceArray
         },

         loadMemContents: function(memoryFileContent) {
            this.barStatus = 2
            let memoryContentArray
            try {
               memoryContentArray = JSON.parse(memoryFileContent)
            } catch(err) {
               this.barStatus = 3
               this.barStatusText = "JSON syntax error"
               return
            }
            let memoryInstanceArray = this.getMemoryInstanceArray()
            if (memoryInstanceArray.length != memoryContentArray.length) {
               this.barStatus = 3
               this.barStatusText = "Wrong number of memory initialization blocks"
               return
            }

            memoryContentArray.forEach((memoryContent, memoryIndex) => {
               // look for memory equipotentials
               let memEquipotentials = memoryInstanceArray[memoryIndex]
               // check arities
               for (let addr in memoryContent) {
                  let addrLength = memEquipotentials[0].addrs.length
                  let dataLength = memEquipotentials.length
                  let addrArray = binutils.strToBin(addr, addrLength)
                  let dataArray = binutils.strToBin(memoryContent[addr], dataLength)
                  if (dataArray.length !== dataLength || addr.length !== addrLength) {
                     this.barStatus = 3
                     this.barStatusText = `arity issue for ${addr} : ${memoryContent[addr]}`
                     break
                  }
                  // fill memory
                  let status = this.loadMemLine(addr, dataArray, memEquipotentials)
                  if (status.length > 0) {
                     this.barStatus = 3
                     this.barStatusText = status
                     break
                  }
               }
            })
            if (this.barStatus === 2) {
               this.barStatusText = "MEMORY LOADED"
            }
         },

         loadMemLine: function(addr, dataArray, memEquipotentials) {
            for (let i = 0; i < addr.length; i++) {
               if (addr[i] !== '0' && addr[i] !== '1') {
                  return 'ADDRESS ISSUE'
               }
            }
            let arity = memEquipotentials.length
            for (let i = 0; i < arity; i++) {
               let equipotential = memEquipotentials[i]
               let value = dataArray[arity - equipotential.memOutIndex - 1]
               if (value !== '0' && value !== '1') {
                  return 'VALUE ISSUE'
               }
               let boolValue = (value === '0') ? false : true
               let saddr = Array.prototype.map.call(addr, function(digit) {
                  if (digit === '0') return false
                  if (digit === '1') return true
               }).join(',')
               equipotential.dict[saddr] = boolValue
            }
            return ''
         },

      },

  }

</script>



// WEBPACK FOOTER //
// ShdlSimulator.vue?7e5c3954